import * as alertRulesActions from './alertRulesActions';
import alertRulesReducer from './alertRulesReducer';
import alertRulesSagas from './alertRulesSagas';
import * as alertRulesSelectors from './alertRulesSelectors';
import * as alertRulesTypes from './alertRulesTypes';

const REDUCER_KEY = alertRulesTypes.REDUCER_KEY;
const ALERT_RULES_VERSION_NUMBER = 2;

export {
  ALERT_RULES_VERSION_NUMBER,
  alertRulesActions,
  alertRulesReducer,
  alertRulesSagas,
  alertRulesSelectors,
  alertRulesTypes,
  REDUCER_KEY,
};
